export default __webpack_public_path__ + "static/media/computer.3de376fb.jpg";